'use client';

import { Divider } from '@ads/components-react';
import { cn } from '@linka/utils';
import { LinkButton } from '../link-button/link-button';

interface FooterLink {
  key: string;
  label: string;
  href?: string;
  onClick?: () => void;
}

export interface FooterProps {
  copyrightText: string;
  links?: FooterLink[];
  helpText?: string;
  helpLink?: FooterLink;
  areaLink?: FooterLink;
  className?: string;
}

export const Footer = ({ copyrightText, links, helpText, helpLink, areaLink, className }: FooterProps) => (
  <footer
    className={cn(
      'w-full flex flex-col items-center gap-xxxs py-md text-center px-xxxs bg-ctx-layout-surface',
      className,
    )}
  >
    <a href='/' aria-label='Linka Eventos'>
      <img
        src='/svg/logo-linka-xxl-horizontal.svg'
        alt='Linka Eventos'
        width={320}
        height={109}
        className='w-[9rem] h-auto'
      />
    </a>
    <div>
      <p className='ts-caption-xxs text-ctx-content-title'>{copyrightText}</p>
      {links && links.length > 0 && (
        <div className='flex items-center gap-nano mt-nano'>
          {links.map((link, index) => (
            <span key={link.key} className='flex items-center gap-quark'>
              {index > 0 && <span aria-hidden>•</span>}
              <LinkButton className='ts-paragraph-xxs' type='button' href={link.href} onClick={link.onClick}>
                {link.label}
              </LinkButton>
            </span>
          ))}
        </div>
      )}
    </div>
    {areaLink && <Divider aria-hidden />}
    <div className='flex flex-col items-center gap-nano'>
      {(helpText || helpLink) && (
        <p className='ts-paragraph-xxs text-ctx-content-title'>
          {helpText}{' '}
          {helpLink && (
            <LinkButton className='ts-paragraph-xxs' type='button' href={helpLink.href} onClick={helpLink.onClick}>
              {helpLink.label}
            </LinkButton>
          )}
        </p>
      )}
      {areaLink && (
        <LinkButton className='ts-paragraph-xxs' type='button' href={areaLink.href} onClick={areaLink.onClick}>
          {areaLink.label}
        </LinkButton>
      )}
    </div>
  </footer>
);
